import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
import React, { useContext } from 'react';
import { Form } from 'semantic-ui-react';
import _startCase from 'lodash/startCase';
import { getOptions, validateFormField } from './LocationSelect.utils';
import { FormFieldPropType } from '../../../../../types/FormField.types';
import { DynamicFormContext } from '../../../context/DynamicFormContext';
function LocationSelect(_ref) {
  var field = _ref.field,
    value = _ref.value;
  var _useContext = useContext(DynamicFormContext),
    locations = _useContext.locations,
    hideLabels = _useContext.hideLabels,
    isFormDisabled = _useContext.isFormDisabled,
    onChange = _useContext.onChange,
    formErrors = _useContext.formErrors,
    setFormErrors = _useContext.setFormErrors,
    clearFieldError = _useContext.clearFieldError,
    displayErrors = _useContext.displayErrors;
  var label = field.label,
    name = field.name,
    placeholder = field.placeholder,
    required = field.required,
    disabled = field.disabled;
  var options = getOptions(locations);
  function handleChange(e, _ref2) {
    var fieldName = _ref2.name,
      newLocationName = _ref2.value;
    clearFieldError(name);
    onChange(e, {
      name: fieldName,
      value: newLocationName
    });
    var error = validateFormField(field, newLocationName);
    if (error) {
      setFormErrors(function (prevState) {
        return _objectSpread(_objectSpread({}, prevState), error);
      });
    }
  }
  return /*#__PURE__*/React.createElement(Form.Select, {
    disabled: isFormDisabled || disabled,
    error: displayErrors && formErrors[name],
    required: required,
    name: name,
    label: hideLabels ? null : _startCase(label),
    placeholder: placeholder,
    value: value,
    options: options,
    onChange: handleChange
  });
}
export default LocationSelect;